import { ProjectItem } from '../types';

const projects: ProjectItem[] = [

  // ── AI & Computer Vision Solutions ───────────────────────
  {
    id: 1,
    title: 'Visual Inspection & Quality Assurance',
    description:
      'AI-powered visual inspection system for manufacturing environments — automating defect detection and real-time quality monitoring across production lines.',
    categories: [
      { label: 'Computer Vision', type: 'cv' },
    ],
    emoji: '🔍',
    bgClass: 'bg-cv',
    featured: true,
  },
  {
    id: 3,
    title: 'Medical Image Analysis & Diagnostics',
    description:
      'AI-assisted platform for analysing medical imaging data — supporting clinical workflows and enabling faster, more informed diagnostic decisions.',
    categories: [
      { label: 'Computer Vision', type: 'cv' },
    ],
    emoji: '🩺',
    bgClass: 'bg-ml',
  },
  {
    id: 4,
    title: 'Intelligent Surveillance & Monitoring',
    description:
      'Edge-deployed visual monitoring system with automated event detection — delivering real-time alerts and operational visibility across distributed sites.',
    categories: [
      { label: 'Computer Vision', type: 'cv' },
    ],
    emoji: '📷',
    bgClass: 'bg-ai',
  },
  {
    id: 6,
    title: 'Field & Asset Monitoring System',
    description:
      'AI-driven monitoring solution analysing imagery from field environments — enabling early issue detection and timely intervention for better operational outcomes.',
    categories: [
      { label: 'Computer Vision', type: 'cv' },
    ],
    emoji: '🌾',
    bgClass: 'bg-cv',
  },

  // ── Business Intelligence & Analytics Solutions ───────────
  {
    id: 2,
    title: 'Unified Analytics & Reporting Platform',
    description:
      'Centralised BI platform integrating data from multiple business systems — delivering real-time dashboards and actionable insights for faster, data-driven decisions.',
    categories: [
      { label: 'Business Intelligence & Analytics', type: 'bi' },
    ],
    emoji: '📊',
    bgClass: 'bg-bi',
  },
  {
    id: 5,
    title: 'Enterprise Data & Insights Platform',
    description:
      'AI-powered platform enabling teams to search, access, and extract insights from large volumes of business data — improving knowledge flow and decision-making across the organisation.',
    categories: [
      { label: 'Business Intelligence & Analytics', type: 'bi' },
    ],
    emoji: '💡',
    bgClass: 'bg-bi',
  },
  {
    id: 7,
    title: 'Demand Forecasting & Planning Solution',
    description:
      'Predictive analytics platform combining operational data and market signals — supporting inventory planning and demand forecasting across distribution networks.',
    categories: [
      { label: 'Business Intelligence & Analytics', type: 'bi' },
    ],
    emoji: '📈',
    bgClass: 'bg-nlp',
  },

  // ── AI-Based Maintenance Planning & Scheduling ────────────
  {
    id: 8,
    title: 'Predictive Maintenance & Scheduling System',
    description:
      'AI-powered maintenance platform using sensor data and anomaly detection — enabling proactive scheduling and minimising unplanned equipment downtime.',
    categories: [
      { label: 'Maintenance Planning & Scheduling', type: 'iot' },
    ],
    emoji: '⚙️',
    bgClass: 'bg-iot',
    featured: true,
  },

];

export default projects;